import React, { useState, useEffect, useRef } from 'react'
import { ArrowRightIcon, ArrowLeftIcon, ChevronLeftIcon, ChevronRightIcon, ChevronDoubleLeftIcon, ChevronDoubleRightIcon, FunnelIcon, ArrowLongDownIcon, ArrowLongUpIcon, InformationCircleIcon } from "@heroicons/react/24/outline";

import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Typography,
  Button,
  Chip,
  Avatar,
  IconButton,
  Tooltip,
  Slider,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Checkbox,
  Input,
  Spinner
} from "@material-tailwind/react";
import { useTranslation } from 'react-i18next';
import { getAllDomainsOnlySrc101Numbers } from '../../util/stamp-api';
import numbers from './data.json';
import { filter } from 'lodash';

export default function HotDomains(props) {
  const {showHotDomain, setShowHotDomain, type, handleDomain} = props
  const scrollRef = useRef();

  const { t, i18n } = useTranslation();

  const [checked, setChecked] = useState([true, true, true, true]);
  const [data, setData] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [pos, setPos] = useState(0);
  const [step, setStep] = useState(window.innerWidth < 600 ? 16 : 240);
  const [key, setKey] = useState('');
  const [minted, setMinted] = useState(0);
  const [numberTotal, setNumberTotal] = useState(11110);
  const [loading, setLoading] = useState(false);
  const [currentNumber, setCurrentNumber] = useState();
  const [currentAvailable, setCurrentAvailable] = useState(0);
  const [currentMinted, setCurrentMinted] = useState(0);

  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);

  useEffect(() => {
    fetchDomain();
  }, [showHotDomain])

  useEffect(() => {
    if (type == "btc")
      setChecked([false, false, true, true])
    else 
      setChecked([true, true, true, true])
  }, [type])


  const scrollToTop = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    setLoading(true);
    let temp = [];
    let amount = 0;
    for (let res of data) {
      if (res.number.includes(key) && ((checked[0] && res.number.length == 1) || (checked[1] && res.number.length == 2) || (checked[2] && res.number.length == 3) || (checked[3] && res.number.length == 4))) {
        temp.push(res);
        if (res.minted) amount ++;
      }
    }
    setSelectedData(temp);
    setCurrentAvailable(temp.length);
    setCurrentMinted(amount);

    setLoading(false);
    setPage(1);
    setTotal(Math.ceil(temp.length / step));
  }, [checked, data, key])

  const fetchDomain = async () => {
    if (showHotDomain) {
      setLoading(true);
      let results = await getAllDomainsOnlySrc101Numbers(type);
      let temp = [];
      for(let number of numbers) {
        let flag = 0;
        for(let result of results) {
          if (number == result.realDomain) {
            flag = 1;
            break;
          }
        }
        if (flag == 1) {
          temp.push({number: number, minted: true})
        }
        else {
          temp.push({number: number, minted: false})
        }
      }
      setData(temp);
      setMinted(results.length);
      setLoading(false);
    }
  }

  const handleChecked = (isChecked, index) => {
    const updatedChecked = [...checked];
    updatedChecked[index] = isChecked;
    setChecked(updatedChecked);
  };

  const next = () => {
    if (page === total) return;
    setPage(page + 1);
  };
 
  const prev = () => {
    if (page === 1) return;
    setPage(page - 1);
  };

  const doublePrev = () => {
    setPage(1);
  }

  const doubleNext = () => {
    setPage(total);
  }

  const handleClick = (data) => {
    setCurrentNumber(data.number);
  }

  const handleSelect = () => {
    handleDomain(currentNumber);
    setShowHotDomain(false);
  }
  return (
    <Dialog
      open={showHotDomain}
      className="bg-gray-900 border-gray-600 border-solid border-[1px] md:h-[800px] h-[450px] overflow-scroll"
      size={"lg"}
    >
      <DialogBody>
        <div className='flex flex-col gap-3 w-full items-center md:p-3 p-1'>
          <div className="flex md:flex-row flex-col md:justify-between w-full gap-2">
            <div className="flex md:flex-row flex-col md:gap-5 gap-2">
              <div className="flex flex-row md:gap-1 gap-0 items-center">
                <span className="text-white font-bold">{t('Digits')}:</span>
                {
                  type == "btc" ?
                  <></>:
                  <>
                  <Checkbox 
                    color="pink"
                    label={<Typography color="white" className="flex font-medium">1</Typography>}
                    onClick={(e) => handleChecked(e.target.checked, 0)}
                    checked = {checked[0]}
                  />
                  <Checkbox 
                    color="pink"
                    label={<Typography color="white" className="flex font-medium">2</Typography>}
                    onClick={(e) => handleChecked(e.target.checked, 1)}
                    checked = {checked[1]}
                  />
                  </>
                }
                <Checkbox 
                  color="pink"
                  label={<Typography color="white" className="flex font-medium">3</Typography>}
                  onClick={(e) => handleChecked(e.target.checked, 2)}
                  checked = {checked[2]}
                />
                <Checkbox 
                  color="pink"
                  label={<Typography color="white" className="flex font-medium">4</Typography>}
                  onClick={(e) => handleChecked(e.target.checked, 3)}
                  checked = {checked[3]}
                />
              </div>
              <div className="flex flex-row gap-2">
                <div className="flex flex-row gap-1 items-center">
                  <div className="bg-white p-3"></div>
                  <div className="text-white font-bold text-[18px]">{t('Available')}: (<span className="font-bold text-blue-800">{currentAvailable - currentMinted}</span>)</div>
                </div>
                <div className="flex flex-row gap-1 items-center">
                  <div className="bg-primary p-3"></div>
                  <div className="text-white font-bold text-[18px]">{t('Minted')}: (<span className="font-bold text-blue-800">{currentMinted}</span>)</div>
                </div>
              </div>
            </div>
            <div className="md:max-w-[250px] w-full">
              <Input label={t('Search')} type="text" color="white" value={key} onChange = {(e) => {setKey(e.target.value)}}/>
            </div>
          </div>
          {
            loading ? <Spinner className="h-12 w-12 fixed top-[50%]" /> : <></>
          }
          <div ref={scrollRef} className="md:h-[520px] h-[168px] overflow-scroll w-full">
          {
            <div className="grid xl:grid-cols-20 lg:grid-cols-15 md:grid-cols-10 grid-cols-4 gap-1 w-full">
              {
                selectedData.slice((page-1) * step, page * step).map((data) => {
                  return (
                    <div key= {data.number} className= {`${data.minted ? 'bg-primary text-white' : 'bg-white text-black'} text-center px-1 py-2 font-bold cursor-pointer text-[14px]`} onClick={() => {handleClick(data)}}>
                      {data.number}
                    </div>
                  )
                })
              }
            </div>
          }
          </div>
          {
            total > 1 ? 
            <div className="flex flex-row items-center justify-center gap-8 md:mt-5 mt-2">
              <div className="flex flex-row items-center md:gap-2 gap-1">
                <IconButton
                  size="sm"
                  variant="outlined"
                  onClick={doublePrev}
                  disabled={page === 1}
                  className="bg-primary hover:bg-primary-hover"
                >
                  <ChevronDoubleLeftIcon strokeWidth={2} className="h-4 w-4" />
                </IconButton>
                <IconButton
                  size="sm"
                  variant="outlined"
                  onClick={prev}
                  disabled={page === 1}
                  className="bg-primary hover:bg-primary-hover"
                >
                  <ChevronLeftIcon strokeWidth={2} className="h-4 w-4" />
                </IconButton>
              </div>
              <Typography color="white" className="font-normal">
                 <strong className="text-primary">{page}</strong> of{" "}
                <strong className="text-primary">{total}</strong>
              </Typography>
              <div className="flex flex-row items-center gap-2">
                <IconButton
                  size="sm"
                  variant="outlined"
                  onClick={next}
                  disabled={page === total}
                  className="bg-primary hover:bg-primary-hover"
                >
                  <ChevronRightIcon strokeWidth={2} className="h-4 w-4" />
                </IconButton>
                <IconButton
                  size="sm"
                  variant="outlined"
                  onClick={doubleNext}
                  disabled={page === total}
                  className="bg-primary hover:bg-primary-hover"
                >
                  <ChevronDoubleRightIcon strokeWidth={2} className="h-4 w-4" />
                </IconButton>
              </div>
            </div>
            :
            <></>
          }
          <div className="text-lg">
            <span className="text-white font-bold">{t('Selected')}: </span> 
            <span className="text-primary font-bold">{currentNumber}</span>
          </div>
          <div className="flex flex-row w-full justify-center gap-3 ">
            <button className="bg-primary hover:bg-primary-hover rounded-md py-2 sm:min-w-[200px] min-w-[120px] my-3 text-white" onClick={handleSelect}>{t('CONFIRM')}</button>
            <button className="bg-gray-600 rounded-md py-2 sm:min-w-[200px] min-w-[120px] my-3 text-white" onClick={() => setShowHotDomain(false)}>{t('CLOSE')}</button>
          </div>
        </div>
      </DialogBody>
    </Dialog>
  )
}
